import { MechanicValidatorLargestArmy } from '@colonist/game-mechanic-validators';
import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { useMapValidator } from './useMapValidator.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
export const useMechanicValidatorLargestArmy = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicLargestArmyState = useGameStore((state)=>state.gameState.mechanicLargestArmyState);
    return useMemo(()=>{
        if (!mechanicLargestArmyState) return undefined;
        return new MechanicValidatorLargestArmy(playerValidators, mapValidator, mechanicLargestArmyState);
    }, [
        playerValidators,
        mapValidator,
        mechanicLargestArmyState
    ]);
};
